import { useController, useForm } from 'react-hook-form';
import { salesPriceSchema, SalesPriceSchema } from '../editCampaignSchema';
import { yupResolver } from '@hookform/resolvers/yup';
import { useCallback, useState } from 'react';
import { BaseCampaignItem } from '@retail/campaign/types';
import { useAppTFunction } from '@retail/app/i18n';
import { GridRowId } from '@mui/x-data-grid-premium';

interface Props<T extends BaseCampaignItem> {
  handleSubmitSalesPrice?: (item: T, salesPrice: number) => Promise<void>;
}

export const useEditSalesPrice = <T extends BaseCampaignItem>({
  handleSubmitSalesPrice,
}: Props<T>) => {
  const t = useAppTFunction();
  const [editingCellId, setEditingCellId] = useState<GridRowId>();

  const salesPriceFormMethods = useForm<SalesPriceSchema>({
    resolver: yupResolver(salesPriceSchema(t)),
  });

  const salesPriceController = useController({
    name: 'salesPrice',
    control: salesPriceFormMethods.control,
  });

  const onSubmitSalesPrice = useCallback(
    (item: T) =>
      salesPriceFormMethods.handleSubmit(async ({ salesPrice }) => {
        await handleSubmitSalesPrice?.(item, salesPrice);
        setEditingCellId(undefined);
        salesPriceFormMethods.reset();
      }, console.error),
    [handleSubmitSalesPrice, salesPriceFormMethods]
  );

  return {
    salesPriceFormMethods,
    salesPriceController,
    onSubmitSalesPrice,
    editingCellId,
    setEditingCellId,
  };
};
